import React from 'react'

const IconThumbsUpButton = ({ isClicked = false, fill = '#fff' }) => {
  return (
    <>
      {isClicked ? (
        <svg
          width='32'
          height='32'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect width='32' height='32' rx='16' fill='#21B979' />
          <mask
            id='mask0_18101_38975'
            style={{
              maskType: 'alpha',
            }}
            maskUnits='userSpaceOnUse'
            x='6'
            y='6'
            width='20'
            height='20'
          >
            <rect x='6' y='6' width='20' height='20' fill='#D9D9D9' />
          </mask>
          <g mask='url(#mask0_18101_38975)'>
            <path
              d='M11.8512 22.167V13.8337L17.2422 8.50684L17.9041 8.71038L17.0691 13.8337H24.1654V15.7873L21.4539 22.167H11.8512ZM12.5179 21.5004H21.0147L23.4987 15.6718V14.5004H16.3256L17.1862 9.46996L12.5179 14.1062V21.5004ZM7.83203 22.167V13.8337H11.8512V14.5004H8.4987V21.5004H11.8512V22.167H7.83203Z'
              fill='white'
            />
          </g>
        </svg>
      ) : (
        <svg
          width='32'
          height='32'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect x='0.5' y='0.5' width='31' height='31' rx='15.5' stroke='#21B979' fill={fill} />
          <mask
            id='mask0_18101_3578'
            style={{
              maskType: 'alpha',
            }}
            maskUnits='userSpaceOnUse'
            x='6'
            y='6'
            width='20'
            height='20'
          >
            <rect x='6' y='6' width='20' height='20' fill='#D9D9D9' />
          </mask>
          <g mask='url(#mask0_18101_3578)'>
            <path
              d='M11.8512 22.167V13.8337L17.2422 8.50684L17.9041 8.71038L17.0691 13.8337H24.1654V15.7873L21.4539 22.167H11.8512ZM12.5179 21.5004H21.0147L23.4987 15.6718V14.5004H16.3256L17.1862 9.46996L12.5179 14.1062V21.5004ZM7.83203 22.167V13.8337H11.8512V14.5004H8.4987V21.5004H11.8512V22.167H7.83203Z'
              fill='#21B979'
            />
          </g>
        </svg>
      )}
    </>
  )
}

export default IconThumbsUpButton
